export const RadioTestIdFactory = {
    // bases, individual radio input
    getRadioInputBase: () => 'radio-input',
    getRadioInputContainerBase: () => [RadioTestIdFactory.getRadioInputBase(), 'container'].join('-'),
    getRadioInputInputBase: () => [RadioTestIdFactory.getRadioInputBase(), 'input'].join('-'),
    getRadioInputDescriptionBase: () => [RadioTestIdFactory.getRadioInputBase(), 'description'].join('-'),
    // for test id generation
    getRadioInputContainerTestId: (testId) => [RadioTestIdFactory.getRadioInputContainerBase(), testId].join('-'),
    getRadioInputInputTestId: (testId) => [RadioTestIdFactory.getRadioInputInputBase(), testId].join('-'),
    getRadioInputDescriptionTestId: (testId) => [RadioTestIdFactory.getRadioInputDescriptionBase(), testId].join('-'),
    // bases, radio group
    getRadioGroupBase: () => 'radio-group',
    getRadioGroupContainerBase: () => [RadioTestIdFactory.getRadioGroupBase(), 'container'].join('-'),
    // for test id generation
    getRadioGroupContainerTestId: (testId) => [RadioTestIdFactory.getRadioGroupContainerBase(), testId].join('-'),
    // internal don't use outside of component
    internalGenerateRadioItemTestId: (testId, itemValue) => [testId, itemValue].join('-'),
};
